import type { ContactWorkbenchColumnKey, ContactWorkbenchListParams } from "../types";

export const crmContactWorkbenchQueryRootKey = ["crm_contact_workbench"] as const;

/** 联系人动态单张图片上限，与媒体接口 contact_record 用途一致。 */
export const CONTACT_RECORD_IMAGE_MAX_BYTES = 20 * 1024 * 1024;

/** 联系人动态单个视频上限。 */
export const CONTACT_RECORD_VIDEO_MAX_BYTES = 150 * 1024 * 1024;

export const crmContactWorkbenchDefaultListParams: ContactWorkbenchListParams = {
  page: 1,
  pageSize: 20,
  sortField: "last_contact_at",
  sortDirection: "desc",
};

export const crmContactWorkbenchColumnOptions: Array<{
  key: ContactWorkbenchColumnKey;
  label: string;
  required?: boolean;
}> = [
  { key: "contact", label: "联系人", required: true },
  { key: "org", label: "学校/院系", required: true },
  { key: "owners", label: "主销售/共享销售", required: true },
  { key: "phone", label: "手机/微信" },
  { key: "area", label: "省/市区" },
  { key: "recordLabel", label: "动态标签" },
  { key: "record", label: "动态" },
  { key: "latestRecord", label: "最近动态" },
  { key: "status", label: "状态" },
  { key: "star", label: "星级" },
  { key: "gift", label: "礼品" },
  { key: "createdAt", label: "新增时间" },
  { key: "updatedAt", label: "更新时间" },
];

export const crmContactWorkbenchDefaultVisibleColumns: ContactWorkbenchColumnKey[] =
  crmContactWorkbenchColumnOptions.map((item) => item.key);

/** 星级固定下拉值；展示文案对齐旧系统说明。 */
export const CONTACT_STAR_OPTION_DESCRIPTIONS: Record<string, string> = {
  A1合作: "合作> 大于6次/100人以上/团队做主人/管事院长书记/行业学术大咖/资源广的老师",
  A2未合作: "合作> 出行人数100人以上，团队做主人/管事院长书记/行业学术大咖/资源广的老师",
  B1已合作: "合作次数3-6次/ 50-100人做主老师",
  B2未合作: "50-100人做主老师或有资源的普通老师",
  B3有合作: "不做主的随团老师",
  C1已合作: "合作次数<3次 / 40人以下做主老师",
  C2未合作: "40人以下/人数未知的做主老师或有资源的普通老师",
  C3: "高校老师（行政岗位或非出行专业老师），非负责老师座机座机记录",
  准客户维护开发: "",
  潜在客户: "无出行或不确定，未合作，出行人数未知，在学校工作的学生",
  无效客户: "不在学校工作的学生，空号，电话错误，退休，已故，非高校老师",
  一级维护: "花儿自身原因，得罪了的A级客户，需随时抓住机会示好维护",
  问题客户: "挑刺儿，破坏花儿名声，恶意欠款3000元以上，对花儿工作人员不尊重辱骂",
};

/** 格式化星级下拉展示文案。 */
export function formatContactStarOptionLabel(value: string): string {
  const description = CONTACT_STAR_OPTION_DESCRIPTIONS[value];
  if (description === undefined) {
    return value;
  }
  if (!description) {
    return `【${value}】`;
  }
  return `【${value}】 ${description}`;
}
